import initAnalytics from './init-analytics'
import getTracker from './get-tracker'

const config = window.addiesaas.google_analytics
const EventBus = window.addiesaas.$core.EventBus

function init() {
    const analytics = initAnalytics(config)

    if (analytics) {
        const tracker = getTracker(config)

        config.tracker = tracker

        if (tracker) {
            EventBus.$on('google-analytics.router.after-each', route => {
                const page = {
                    url: window.location.origin + route.fullPath,
                    path: route.path,
                }

                analytics.page(page)
            })

            EventBus.$on('cart.paid', order => tracker.trackPurchase(config, order, analytics))
            EventBus.$on('payment-processed', order => tracker.trackPurchase(config, order, analytics))
        }
    }
}

if (config.is_active) {
    if (document.body) {
        init()
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            init()
        })
    }
}
